import "core-js/modules/es.array.fill.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var _hoisted_2 = {
  "clip-path": "url(#clip0_390_327)"
};
var _hoisted_3 = ["fill"];

var _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_390_327"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "27.39",
  height: "22.15",
  fill: "white",
  transform: "translate(8.66635 11)"
})])], -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M9.39635 33.15C9.29991 33.1493 9.20464 33.1288 9.11635 33.09C8.97563 33.0319 8.8566 32.9313 8.77591 32.8022C8.69522 32.6731 8.65691 32.522 8.66635 32.37C8.66635 32.23 9.83635 18.37 24.7464 16.83V11.73C24.7445 11.5859 24.7865 11.4446 24.8669 11.3249C24.9473 11.2052 25.0622 11.1128 25.1964 11.06C25.328 11.0036 25.4735 10.9877 25.6142 11.0145C25.755 11.0412 25.8845 11.1093 25.9864 11.21L35.8464 21.07C35.9144 21.1382 35.968 21.2194 36.0041 21.3087C36.0401 21.3981 36.0579 21.4937 36.0564 21.59C36.0583 21.6849 36.0407 21.7792 36.0045 21.8669C35.9684 21.9547 35.9145 22.034 35.8464 22.1L25.9864 32C25.8849 32.1013 25.7559 32.1705 25.6154 32.1989C25.475 32.2274 25.3292 32.2139 25.1964 32.16C25.0614 32.1055 24.9461 32.0113 24.8658 31.8899C24.7855 31.7685 24.7438 31.6256 24.7464 31.48V26.38C19.1588 26.5723 13.8595 28.9069 9.94635 32.9C9.87783 32.9785 9.7933 33.0415 9.69843 33.0846C9.60356 33.1277 9.50056 33.15 9.39635 33.15ZM26.2064 13.49V17.49C26.2068 17.6753 26.1368 17.8538 26.0105 17.9893C25.8842 18.1249 25.7112 18.2073 25.5264 18.22C14.6664 19.05 11.4364 26.57 10.4964 30.35C14.6876 26.8012 20.0045 24.8588 25.4964 24.87C25.5922 24.87 25.6871 24.8889 25.7757 24.9256C25.8643 24.9623 25.9448 25.0161 26.0125 25.0838C26.0803 25.1516 26.1341 25.2321 26.1708 25.3207C26.2075 25.4092 26.2264 25.5042 26.2264 25.6V29.68L34.3164 21.59L26.2064 13.49Z",
    fill: $props.fill
  }, null, 8, _hoisted_3)]), _hoisted_4]);
}